var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toolbar"},[_c('div',{staticClass:"toolbar-content"},[_c('v-btn',{staticClass:"radius-rounded",attrs:{"icon":""},on:{"click":() => {
          _setup.router.back();
        }}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1),_c('div',{staticClass:"toolbar-title"},[_vm._t("title")],2),_vm._t("actions")],2),_c('v-progress-linear',{attrs:{"active":_setup.comicStore.isProgressBarLoading,"indeterminate":"","height":"3","color":"secondary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }